import { sendData } from "../../utils.js";
import { calculateOrderPrice } from "./deliveryOrder.js";
import { dispatchOrderValidate } from "./orderValidation.js";
import { addCdekAddressToDropdown, updateDropdownContentCdek } from "./cdek-dropdown.js";

// Константа для ключа (оставлено для совместимости с вызовами)
const CDEK_ADDRESSES_KEY = 'cdek_selected_addresses';

// Храним инстанс карты CDEK, чтобы понимать инициализирована ли она
let cdekMapInstance = null;
let cdekInitOptions = {};

function ensureOrderState() {
    if (!window.__orderState) {
        window.__orderState = { cdekSelectedAddresses: [], personalAddresses: [] };
    } else {
        if (!Array.isArray(window.__orderState.cdekSelectedAddresses)) {
            window.__orderState.cdekSelectedAddresses = [];
        }
        if (!Array.isArray(window.__orderState.personalAddresses)) {
            window.__orderState.personalAddresses = [];
        }
    }
}

function updateCdekDropdownHeader(city, address) {
    try {
        const cdekDropdowns = document.querySelectorAll('.item-delivery .dropdown');
        const cdekDropdown = cdekDropdowns && cdekDropdowns[1];
        if (!cdekDropdown) return;
        const dropdownHeader = cdekDropdown.querySelector('.dropdown__header__text');
        if (!dropdownHeader) return;
        dropdownHeader.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                <path d="M11.2111 1.65423C10.5179 1.03951 9.70243 0.57837 8.81834 0.301094C7.93425 0.0238169 7.00151 -0.0633302 6.08135 0.045374C4.46691 0.273565 2.99193 1.08509 1.93505 2.32666C0.878168 3.56823 0.312561 5.15386 0.345078 6.78402C0.355587 8.41038 0.953941 9.97807 2.02974 11.1978L5.78653 15.4937C5.9249 15.6527 6.09575 15.7801 6.28755 15.8675C6.47936 15.9548 6.68766 16 6.89841 16C7.10916 16 7.31746 15.9548 7.50927 15.8675C7.70107 15.7801 7.87192 15.6527 8.01029 15.4937L11.7671 11.1978C12.8429 9.97807 13.4412 8.41038 13.4517 6.78402V6.53132C13.4447 5.60612 13.2414 4.69295 12.8551 3.8522C12.4689 3.01145 11.9085 2.26228 11.2111 1.65423ZM12.1377 6.7756C12.1388 8.0931 11.6597 9.36584 10.79 10.3555L7.03318 14.6598C6.92368 14.7777 6.8226 14.7862 6.7131 14.6598L2.9563 10.3555C2.0866 9.36584 1.60745 8.0931 1.60857 6.7756C1.57642 5.45534 2.02925 4.16908 2.8814 3.16016C3.73356 2.15123 4.92594 1.4896 6.23297 1.30045C6.44899 1.28786 6.66555 1.28786 6.88157 1.30045C8.26986 1.30484 9.60042 1.85656 10.5845 2.83587C11.5685 3.81518 12.1266 5.14306 12.1377 6.53132V6.7756Z" fill="#414141" fill-opacity="0.56"/>
                <path d="M6.87261 3.37207C6.24787 3.37207 5.63716 3.55733 5.11771 3.90441C4.59826 4.2515 4.19339 4.74483 3.95431 5.32201C3.71524 5.8992 3.65268 6.53432 3.77456 7.14705C3.89644 7.75979 4.19728 8.32262 4.63904 8.76438C5.0808 9.20614 5.64363 9.50698 6.25637 9.62886C6.86911 9.75074 7.50422 9.68818 8.08141 9.44911C8.65859 9.21003 9.15192 8.80517 9.49901 8.28571C9.84609 7.76626 10.0314 7.15555 10.0314 6.53081C10.0314 5.69306 9.69856 4.88962 9.10618 4.29724C8.5138 3.70487 7.71036 3.37207 6.87261 3.37207ZM6.87261 8.42606C6.49777 8.42606 6.13134 8.3149 5.81967 8.10665C5.508 7.8984 5.26508 7.6024 5.12163 7.25609C4.97819 6.90978 4.94065 6.52871 5.01378 6.16107C5.08691 5.79343 5.26741 5.45573 5.53247 5.19067C5.79752 4.92562 6.13522 4.74511 6.50287 4.67198C6.87051 4.59885 7.25158 4.63639 7.59789 4.77983C7.9442 4.92328 8.2402 5.1662 8.44845 5.47787C8.6567 5.78954 8.76785 6.15597 8.76785 6.53081C8.76785 7.03346 8.56818 7.51552 8.21275 7.87095C7.85732 8.22638 7.37526 8.42606 6.87261 8.42606Z" fill="#414141" fill-opacity="0.56"/>
            </svg>
            ${city} - ${address}
        `;
    } catch (e) {
        // no-op
    }
}

// Публичная функция для фокусировки карты на координатах с небольшим зумом
export function focusCdekMap(coords, preferredZoom) {
    try {
        if (cdekMapInstance) {
            const currentZoom = cdekMapInstance.getZoom ? cdekMapInstance.getZoom() : 13;
            const targetZoom = typeof preferredZoom === 'number' ? preferredZoom : Math.min(currentZoom + 1, 16);
            cdekMapInstance.setCenter(coords, targetZoom, { duration: 300 });
            return;
        }
        // Если карта ещё не инициализирована — инициализируем и центрируем
        cdek(coords);
    } catch (e) {
        console.error('Ошибка при фокусировке CDEK карты:', e);
    }
}

// Функция для получения сохраненных адресов CDEK (из общей переменной)
function getCdekAddresses() {
    try {
        ensureOrderState();
        return [...window.__orderState.cdekSelectedAddresses];
    } catch (error) {
        console.error('Ошибка при получении адресов CDEK из общей переменной:', error);
        return [];
    }
}

// Возвращает последний выбранный адрес CDEK (по selectedAt)
function getLastSelectedCdekAddress() {
    const addresses = getCdekAddresses();
    if (!Array.isArray(addresses) || addresses.length === 0) return null;
    const withDates = addresses.filter(a => a && a.selectedAt);
    if (withDates.length === 0) return addresses[addresses.length - 1];
    withDates.sort((a, b) => new Date(b.selectedAt) - new Date(a.selectedAt));
    return withDates[0];
}

// Функция для сохранения адреса CDEK в общую переменную
function saveCdekAddress(addressData) {
    try {
        ensureOrderState();
        const addresses = [...window.__orderState.cdekSelectedAddresses];
        
        // Проверяем, есть ли уже такой адрес
        const existingIndex = addresses.findIndex(addr => addr.id === addressData.id);
        
        if (existingIndex !== -1) {
            // Обновляем существующий адрес
            addresses[existingIndex] = addressData;
        } else {
            // Добавляем новый адрес
            addresses.push(addressData);
        }
        
        // Ограничиваем количество сохраненных адресов (например, максимум 10)
        if (addresses.length > 10) {
            addresses.shift(); // Удаляем самый старый адрес
        }
        
        window.__orderState.cdekSelectedAddresses = addresses;
        console.log('Адрес CDEK сохранен (глобально):', addressData);
    } catch (error) {
        console.error('Ошибка при сохранении адреса CDEK:', error);
    }
}

// Функция для удаления адреса CDEK
function removeCdekAddress(addressId) {
    try {
        ensureOrderState();
        const addresses = [...window.__orderState.cdekSelectedAddresses];
        const filteredAddresses = addresses.filter(addr => addr.id !== addressId);
        window.__orderState.cdekSelectedAddresses = filteredAddresses;
        console.log('Адрес CDEK удален:', addressId);
    } catch (error) {
        console.error('Ошибка при удалении адреса CDEK:', error);
    }
}

// Функция для очистки всех сохраненных адресов CDEK
function clearCdekAddresses() {
    try {
        ensureOrderState();
        window.__orderState.cdekSelectedAddresses = [];
        console.log('Все адреса CDEK удалены');
    } catch (error) {
        console.error('Ошибка при очистке адресов CDEK:', error);
    }
}

export function cdek(coords, options = {}) {
    const mapCdek = document.querySelector('#cdek-map');
    if(!mapCdek) return;

    console.log('CDEK функция вызвана с координатами:', coords);

    // Запоминаем опции и используем их при дальнейшей инициализации/перерисовке
    cdekInitOptions = options || {};

    // Если карта уже инициализирована, просто меняем центр
    if (cdekMapInstance) {
        try {
            const currentZoom = cdekMapInstance.getZoom ? cdekMapInstance.getZoom() : 13;
            cdekMapInstance.setCenter(coords, currentZoom, { duration: 300 });
            console.log('Карта CDEK уже инициализирована, меняем центр');
            // Дополнительно сразу обновляем список ПВЗ и dropdown под выбранный город
            const cityInputAfterChange = document.querySelector('#find-city-modal');
            const cityNameForUpdate = cityInputAfterChange ? cityInputAfterChange.value : '';
            if (cityNameForUpdate) {
                initPlacemarks(cityNameForUpdate, cdekMapInstance, cdekInitOptions);
            }
        } catch (e) {
            console.error('Ошибка при setCenter для CDEK карты:', e);
        }
        return
    }

    ymaps.ready(init);
    var myMap;

    function init() {
        console.log('Инициализация карты CDEK...');
        
        // Получаем название города из input
        const cityInput = document.querySelector('#find-city-modal');
        const cityName = cityInput ? cityInput.value : '';
        
        console.log('Название города для CDEK:', cityName);
        
        myMap = new ymaps.Map(mapCdek, {
            center: coords,
            zoom: 13,
            controls: []
        });

        // Сохраняем инстанс для повторного использования
        cdekMapInstance = myMap;

        // Используем название города вместо геолокации
        if (cityName) {
            initPlacemarks(cityName, myMap, cdekInitOptions);
        } else {
            // Fallback к геолокации если город не указан
            ymaps.geolocation.get({
                provider: 'yandex',
                autoReverseGeocode: true
            }).then((result)=>{
                let address = result.geoObjects.get(0).getAdministrativeAreas()[1];
                initPlacemarks(address, myMap, cdekInitOptions);
            });
        }

        myMap.events.add('boundschange',(event)=>{
            const newCenter = event.get('newCenter');
            ymaps.geocode(newCenter).then(res=>{
                const firstGeoObject = res.geoObjects.get(0);
                const newAddress = firstGeoObject.getAdministrativeAreas()[1];
                if(!!newAddress && newAddress !== cityName) {
                    initPlacemarks(newAddress, myMap, cdekInitOptions);
                }
            });
        });
    }
}

// Функция для работы с картой магазинов mhand
export function mhand(coords) {
    const mapMhand = document.querySelector('#mhand-map');
    if(!mapMhand) {
        console.log('Элемент #mhand-map не найден');
        return;
    }
    console.log('Элемент #mhand-map найден, инициализируем карту');

    ymaps.ready(initMhand);
    var myMhandMap;

    function initMhand() {
        console.log('ymaps готов, инициализируем карту mhand');
        ymaps.geolocation.get({
            provider: 'yandex',
            autoReverseGeocode: true
        }).then((result)=>{
            // const coords = result.geoObjects.position;
            let address = result.geoObjects.get(0).getAdministrativeAreas()[1];
            console.log('Геолокация получена, создаем карту mhand');
            myMhandMap = new ymaps.Map(mapMhand, {
                center: coords,
                zoom: 13,
                controls: []
            });

            initMhandPlacemarks(address, myMhandMap);

            myMhandMap.events.add('boundschange',(event)=>{
                const newCenter = event.get('newCenter');
                ymaps.geocode(newCenter).then(res=>{
                    const firstGeoObject = res.geoObjects.get(0);
                    const newAddress = firstGeoObject.getAdministrativeAreas()[1];
                    if(!!newAddress && newAddress !== address) {
                        address = newAddress;
                        initMhandPlacemarks(address, myMhandMap);
                    }
                });
            });
        });
    }
}

function setAddrToForm(city, addr) {
    const block = document.querySelector('.delivery__address')
    block.innerHTML = `Адрес доставки: ${city}<br>Пункт выдачи CDEK: ${addr}`
}

function setMhandAddrToForm(city, addr) {
    console.log(`Устанавливаем адрес в форму: ${city} - ${addr}`);
    const block = document.querySelector('.delivery__address')
    if (block) {
        block.innerHTML = `Адрес доставки: ${city}<br>Магазин mhand: ${addr}`;
        console.log('Адрес успешно установлен в форму доставки');
    } else {
        console.log('Элемент .delivery__address не найден');
    }
}

function initPlacemarks(address, map, options = {}) {
    const addressBlock = document.querySelector('.__cdek_map__address');
    
    console.log('Инициализация маркеров CDEK для адреса:', address);

    var myGeoObjects = new ymaps.GeoObjectCollection({}, {
        preset: "islands#redCircleIcon",
        strokeWidth: 4,
        geodesic: true
    });

    console.log('Отправляем запрос к API CDEK для адреса:', address);

    // Формируем полный адрес для API CDEK
    const fullAddress = `Городской округ ${address}, Россия`;
    console.log('Полный адрес для API CDEK:', fullAddress);

    sendData({'address': fullAddress}, '/api/cdek/get-branches/')
    .then(res=>{

        console.log('Ответ от API CDEK:', res);

        const branches = res.branches;
        let placemarks = [];

        console.log('Найдено пунктов выдачи CDEK:', branches ? branches.length : 0);

        updateDropdownContentCdek(branches)

        if(!branches || branches.length === 0){
            console.log('Пункты выдачи CDEK не найдены');
            map.geoObjects.removeAll(myGeoObjects);
            if (addressBlock) addressBlock.innerText = 'Пункты выдачи СДЕК не найдены';
            return;
        } else {
            // Не перетираем выбранный адрес, если уже есть выбранная точка
            if (addressBlock && !addressBlock.dataset.id) addressBlock.innerText = 'Не выбрано';
        }
        const autoSelectFirst = !(options && options.skipInitialSelect);
        let active = autoSelectFirst;
        for(const info of branches) {
            const location = [info.location.latitude, info.location.longitude];
            let placemark = new ymaps.Placemark(location, {}, {
                iconLayout: "default#image",
                iconImageHref: '/static/assets/images/map-pin-cdek.png',
                iconImageSize: [54, 60],
                iconImageOffset: [-27, -60],
            });

            myGeoObjects.add(placemark);
            placemarks.push(placemark);
            if (active) {
                const orderForm = document.querySelector('#order-form');
                orderForm.dataset.city_name = info.location.city;

                placemarks.forEach(unactive=>{
                    unactive.options.set('iconImageHref', '/static/assets/images/map-pin-cdek.png');
                });
                placemark.options.set('iconImageHref', '/static/assets/images/map-pin-cdek-active.png');
                if (addressBlock) {
                    addressBlock.innerText = `${info.location.address}`;
                    addressBlock.dataset.city = info.location.city;
                    addressBlock.dataset.id = info.code;
                }
                setAddrToForm(info.location.city, info.location.address)

                calculateOrderPrice(addressBlock ? addressBlock.dataset.city : info.location.city, '136');
                dispatchOrderValidate();
                updateCdekDropdownHeader(info.location.city, info.location.address);
                active = false
            }
            placemark.events.add('click', ()=>{
                const orderForm = document.querySelector('#order-form');
                orderForm.dataset.city_name = info.location.city;

                placemarks.forEach(unactive=>{
                    unactive.options.set('iconImageHref', '/static/assets/images/map-pin-cdek.png');
                });
                placemark.options.set('iconImageHref', '/static/assets/images/map-pin-cdek-active.png');
                if (addressBlock) {
                    addressBlock.innerText = `${info.location.address}`;
                    addressBlock.dataset.city = info.location.city;
                    addressBlock.dataset.id = info.code;
                }
                setAddrToForm(info.location.city, info.location.address)

                calculateOrderPrice(addressBlock ? addressBlock.dataset.city : info.location.city, '136');
                dispatchOrderValidate();
                updateCdekDropdownHeader(info.location.city, info.location.address);
                // Сохраняем выбранный адрес в глобальное состояние
                const addressData = {
                    id: info.code,
                    city: info.location.city,
                    address: info.location.address,
                    lat: info.location.latitude,
                    lng: info.location.longitude,
                    selectedAt: new Date().toISOString(),
                    type: 'cdek'
                };
                saveCdekAddress(addressData);
                
                // Добавляем адрес в dropdown
                addCdekAddressToDropdown(addressData);

                // Центрируем карту на выбранной метке и немного увеличиваем зум
                focusCdekMap([info.location.latitude, info.location.longitude]);
                
                const menuSection = document.querySelector('.order-section__menu');
                if (menuSection) {
                    setTimeout(() => {
                        menuSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 300);
                }
            });
        };

        console.log('Добавляем', placemarks.length, 'маркеров CDEK на карту');
        map.geoObjects.add(myGeoObjects);
        console.log('Маркеры CDEK успешно добавлены на карту');
    })
    .catch(error=>{
        console.error('Ошибка при получении пунктов выдачи CDEK:', error);
        map.geoObjects.removeAll(myGeoObjects);
        if (addressBlock) {
            addressBlock.innerText = 'Пункты выдачи СДЕК не найдены';
            addressBlock.dataset.city = '';
        }

        dispatchOrderValidate();
    });
}

// Функция для инициализации маркеров магазинов mhand
function initMhandPlacemarks(address, map) {
    console.log('Инициализация маркеров магазинов mhand для адреса:', address);
    const addressBlock = document.querySelector('.__mhand_map__address');

    var myGeoObjects = new ymaps.GeoObjectCollection({}, {
        preset: "islands#redCircleIcon",
        strokeWidth: 4,
        geodesic: true
    });

    // Получаем данные о магазинах mhand из API
    console.log('Запрашиваем данные о магазинах mhand из API...');
    fetch('/api/shops/')
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(res => {
        console.log('Получены данные о магазинах mhand:', res);
        const shops = res.results || [];
        let placemarks = [];

        if(shops.length === 0){
            console.log('Магазины mhand не найдены');
            map.geoObjects.removeAll(myGeoObjects);
            if (addressBlock) addressBlock.innerText = 'Магазины mhand не найдены';
            return;
        } else {
            console.log(`Найдено ${shops.length} магазинов mhand`);
            if (addressBlock) addressBlock.innerText = 'Не выбрано';
        }
        
        let active = false;
        for(const shop of shops) {
            // Проверяем что у магазина есть координаты
            if (!shop.coordinates) {
                console.log(`Магазин ${shop.addr} не имеет координат`);
                continue;
            }
            
            // Парсим координаты из строки "lat, lng"
            let lat, lng;
            try {
                const coords = shop.coordinates.split(',');
                if (coords.length !== 2) {
                    continue;
                }
                lat = parseFloat(coords[0].trim());
                lng = parseFloat(coords[1].trim());
                
                if (isNaN(lat) || isNaN(lng)) {
                    continue;
                }
            } catch (error) {
                continue;
            }
            
            const location = [lat, lng];
            
            let placemark = new ymaps.Placemark(location, {
                balloonContent: `
                    <div style="padding: 10px;">
                        <h4>${shop.addr}</h4>
                        <p><strong>Телефон:</strong> ${shop.phone || 'Не указан'}</p>
                        <p><strong>Часы работы:</strong> ${shop.work_hours || 'Не указаны'}</p>
                    </div>
                `
            }, {
                iconLayout: "default#image",
                iconImageHref: '/static/assets/images/map-pin-mhand.png',
                iconImageSize: [54, 60],
                iconImageOffset: [-27, -60],
            });

            myGeoObjects.add(placemark);
            placemarks.push(placemark);
            
            // Автовыбор первого магазина отключен, ждём явного выбора пользователя
            
            // Добавляем обработчик клика на маркер
            placemark.events.add('click', ()=>{
                console.log(`Клик по маркеру магазина ${shop.addr}`);
                setActiveMhandShop(shop, placemark, placemarks, addressBlock);
            });
        }

        console.log(`Добавляем ${placemarks.length} маркеров на карту`);
        map.geoObjects.add(myGeoObjects);
    })
    .catch(error => {
        console.error('Ошибка при получении данных о магазинах mhand:', error);
        map.geoObjects.removeAll(myGeoObjects);
        if (addressBlock) {
            addressBlock.innerText = 'Магазины mhand не найдены';
            addressBlock.dataset.city = '';
        }
        dispatchOrderValidate();
    });
}

// Функция для установки активного магазина mhand
function setActiveMhandShop(shop, activePlacemark, allPlacemarks, addressBlock) {
    // console.log(`Устанавливаем активный магазин: ${shop.addr} в городе ${shop.city}`);
    
    const orderForm = document.querySelector('#order-form');
    orderForm.dataset.city_name = shop.city;

    // Сбрасываем все маркеры в неактивное состояние
    allPlacemarks.forEach(placemark => {
        placemark.options.set('iconImageHref', '/static/assets/images/map-pin-mhand.png');
    });
    
    // Устанавливаем активный маркер
    activePlacemark.options.set('iconImageHref', '/static/assets/images/map-pin-mhand-active.png');
    
    // Обновляем отображение адреса
    if (addressBlock) {
        addressBlock.innerText = shop.addr;
        addressBlock.dataset.city = shop.city;
        addressBlock.dataset.id = shop.id;
        console.log(`Обновлен адрес в блоке: ${shop.addr}`);
    }
    
    // Переносим адрес в форму доставки
    setMhandAddrToForm(shop.city, shop.addr);
    
    // Устанавливаем адрес в delivery__address если доступна функция
    if (window.setMhandShopAddress) {
        window.setMhandShopAddress(shop);
    }
    // console.log(`Адрес перенесен в форму: ${shop.city} - ${shop.addr}`);

    // Пересчитываем цену заказа
    calculateOrderPrice(shop.city, '136');
    console.log(`Пересчитана цена заказа для города: ${shop.city}`);
    
    // Запускаем валидацию формы
    dispatchOrderValidate();
    // console.log('Запущена валидация формы');
    
    console.log(`Выбран магазин: ${shop.addr} в городе ${shop.city}`);
}

// Экспортируем функции для работы с глобальным хранилищем
export {
    getCdekAddresses,
    saveCdekAddress,
    removeCdekAddress,
    clearCdekAddresses,
    getLastSelectedCdekAddress
};

// Экспортируем функции для глобального использования
window.cdek = cdek;
window.mhand = mhand;
window.getLastSelectedCdekAddress = getLastSelectedCdekAddress;
